import React from 'react';

export const ValidationIcon = () => {
  return <div>ValidationIcon</div>;
};
